import { html, css, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Operation } from "../rules"

type OperatorBoxEntry = {label: keyof Operation, priority: number, tooltip: string};

@customElement("od-operators-box")
export class OutDesignOperatorsBoxElement extends LitElement {
    private elementOperators: Array<OperatorBoxEntry> = [
        {
            label: "classes",
            priority: 3,
            tooltip: "Modify the class attribute"
        },
        {
            label: "type",
            priority: 3,
            tooltip: "Change the type of the element"
        },
        {
            label: "level",
            priority: 2,
            tooltip: "Specify a level for a Header element"
        },
        {
            label: "id",
            priority: 2,
            tooltip: "Add an automatic identifier to all elements"
        },
        {
            label: "attrs",
            priority: 1,
            tooltip: "Add key-value attributes"
        },
        {
            label: "simplify",
            priority: 1,
            tooltip: "Remove the classes, the identifier and the attributes"
        },
    ]

    private structureOperators: Array<OperatorBoxEntry> = [
        {
            label: "delete",
            priority: 3,
            tooltip: "Delete a node"
        },
        {
            label: "empty",
            priority: 1,
            tooltip: "Delete a node if it is empty"
        },
        {
            label: "br",
            priority: 1,
            tooltip: "Delete a node if it only contains a LineBreak"
        },
        {
            label: "group",
            priority: 2,
            tooltip: "Group consecutive selected nodes into the specified parent node"
        },
        {
            label: "join",
            priority: 2,
            tooltip: "Join consecutive selected nodes into only one node separated by the specified element"
        },
        {
            label: "unwrap",
            priority: 3,
            tooltip: "Unwrap the content of the selected node the tree"
        },
        {
            label: "wrap",
            priority: 2,
            tooltip: "Wrap the node into a specified parent node"
        },
    ]

    static styles = css`
    :host {
      display: block;
      border-top: 3px solid #ddd;
      padding: 0.5rem;
    }

    .title {
      font-weight: 600;
      margin-top: 0.25em;
    }

    p {
        margin: 0;
        line-height: 1.8em;
    }

    .operator {
        border: 1px solid rgb(201, 201, 201);
        padding: 0 0.25em;
        line-height: 1.5em;
        border-radius: 3px;
        background: rgb(231, 231, 231);
    }

    .operator:hover {
        background-color: lightgrey;
        transition:
          background-color .15s;
        cursor: pointer;
    }
    `

    private comparePriority(a: OperatorBoxEntry, b: OperatorBoxEntry) {
        return b.priority - a.priority
    }

    private emitOperator(operator: string) {
        this.dispatchEvent(
            new CustomEvent("emit-operator", {
                detail: operator,
                bubbles: true,
                composed: true
            })
        );
    }
    
    render() {
        return html`
        <div class="title">Element operators</div>
        <p class="elementOperators">
            ${this.elementOperators.sort(this.comparePriority).map(
                (operator, i) => html`
                <span id=${`${operator.label}-operator`} class="operator"
                @click=${(e: MouseEvent) => this.emitOperator(operator.label)}>
                ${operator.label}</span>
                <wa-tooltip for=${`${operator.label}-operator`}>${operator.tooltip}</wa-tooltip>
                `
            )}
        </p>
        <div class="title">Structure operators</div>
        <p class="structureOperators">
            ${this.structureOperators.sort(this.comparePriority).map(
                (operator, i) => html`
                <span id=${`${operator.label}-operator`} class="operator"
                @click=${(e: MouseEvent) => this.emitOperator(operator.label)}>
                ${operator.label}</span>
                <wa-tooltip for=${`${operator.label}-operator`}>${operator.tooltip}</wa-tooltip>
                `
            )}
        </p>
        `
    }
}